import React from 'react';
import LumiaLogo from '../../assets/images/lumia.png';
import YoutubeLogo from '../../assets/images/youtube2.png';
import './home.css';

const Home = () => {
	const selectedSite = (site) => {
		switch (site) {
			case 'youtube':
				window.open('https://www.youtube.com/ahadcove', '_blank');
				break;
			case 'twitter':
				window.open('https://twitter.com/AhadCove', '_blank');
				break;
			case 'twitch':
				window.open('https://www.twitch.tv/ahadcove', '_blank');
				break;
			case 'discord':
				window.open('https://discord.gg/zjUrYyG', '_blank');
				break;
			case 'patreon':
				window.open('https://www.patreon.com/ahadcove', '_blank');
				break;
			case 'github':
				window.open('https://github.com/ahadcove', '_blank');
				break;
			case 'lumia':
				window.open('https://lumiastream.com', '_blank');
				break;
		}
	};

	return (
		<div className='home-contain'>
			<div className='home-item-contain' onClick={() => selectedSite('youtube')}>
				<img className='home-item-bg-contain' src={YoutubeLogo} alt="Youtube"></img>
				{/* <div className='home-item-text'>YOUTUBE</div> */}
			</div>
			<div className='home-item-contain' onClick={() => selectedSite('lumia')}>
				<img className='home-item-bg' src={LumiaLogo} alt="Lumia Stream"></img>
				{/* <div className='home-item-text'>LUMIA STREAM</div> */}
			</div>
		</div>
	)
}

export default Home;